import React, { useEffect, memo, Fragment, useState } from "react";
import { Link } from "react-router-dom";
import VerticalNav from "../SidebarStyle/vertical-nav";

//scrollbar
import Scrollbar from "smooth-scrollbar";

// Import selectors
import * as SettingSelector from "../../../../store/setting/selectors";

// Redux Selector
import { useSelector } from "react-redux";
import Logo from "../../components/logo";

const Sidebar = memo((props) => {
  const sidebarColor = useSelector(SettingSelector.sidebar_color);
  const sidebarHide = useSelector(SettingSelector.sidebar_show);
  const sidebarType = useSelector(SettingSelector.sidebar_type);
  const sidebarMenuStyle = useSelector(
    SettingSelector.sidebar_menu_style
  );

  const [isMinimized, setIsMinimized] = useState(false);

  // Toggle sidebar
  const minisidebar = () => {
    const aside = document.getElementsByTagName("ASIDE")[0];
    aside.classList.toggle("sidebar-mini");

    const minimizedNow = aside.classList.contains("sidebar-mini");
    setIsMinimized(minimizedNow);
  };

  useEffect(() => {
    Scrollbar.init(document.querySelector("#my-scrollbar"));

    const aside = document.getElementsByTagName("ASIDE")[0];

    // set initial state
    if (aside) {
      setIsMinimized(aside.classList.contains("sidebar-mini"));
    }

    // observe class changes
    const observer = new MutationObserver(() => {
      if (aside) {
        const minimizedNow = aside.classList.contains("sidebar-mini");
        setIsMinimized(minimizedNow);
      }
    });

    if (aside) {
      observer.observe(aside, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    window.addEventListener("resize", () => {
      const tabs = document.querySelectorAll(".nav");
      const sidebarResponsive = document.querySelector(
        '[data-sidebar="responsive"]'
      );

      if (window.innerWidth < 1025) {
        Array.from(tabs, (elem) => {
          if (
            !elem.classList.contains("flex-column") &&
            elem.classList.contains("nav-tabs") &&
            elem.classList.contains("nav-pills")
          ) {
            elem.classList.add("flex-column", "on-resize");
          }
          return elem.classList.add("flex-column", "on-resize");
        });

        if (sidebarResponsive !== null) {
          if (!sidebarResponsive.classList.contains("sidebar-mini")) {
            sidebarResponsive.classList.add(
              "sidebar-mini",
              "on-resize"
            );
          }
        }
      } else {
        Array.from(tabs, (elem) => {
          if (elem.classList.contains("on-resize")) {
            elem.classList.remove("flex-column", "on-resize");
          }
          return elem.classList.remove("flex-column", "on-resize");
        });

        if (sidebarResponsive !== null) {
          if (
            sidebarResponsive.classList.contains("sidebar-mini") &&
            sidebarResponsive.classList.contains("on-resize")
          ) {
            sidebarResponsive.classList.remove(
              "sidebar-mini",
              "on-resize"
            );
          }
        }
      }
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <Fragment>
      <aside
        className={`${sidebarColor} ${sidebarType.join(
          " "
        )} ${sidebarMenuStyle} ${
          sidebarHide.join(" ") ? "sidebar-none" : "sidebar"
        } sidebar-base`}
        data-sidebar="responsive"
      >
        {/* HEADER */}
        <div className="sidebar-header d-flex align-items-center justify-content-start m-0">

          <Link to="/dashboard" className="navbar-brand">
            <Logo />
            <h4 className="logo-title" style={{ fontSize: "20px" }}>
              {props.app_name}
            </h4>
          </Link>

          {/* Toggle button (circle remains from template CSS) */}
          <div
            className={`sidebar-toggle ${
              isMinimized ? "sidebar-minimized" : ""
            }`}
            data-toggle="sidebar"
            data-active="true"
            onClick={minisidebar}
            style={{ background: "white" }}
          >
            <i
              className="icon"
              style={{
                transform: isMinimized
                  ? "rotate(0deg)"    // ▶ right when minimized
                  : "rotate(180deg)", // ◀ left when expanded
                transition: "transform 0.3s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* FIXED CHEVRON ICON */}
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
  d="M9 6L15 12L9 18"
  stroke="rgb(32, 76, 121)"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
/>
              </svg>
            </i>
          </div>

        </div>

        {/* BODY */}
        <div
          className="pt-0 sidebar-body data-scrollbar"
          data-scroll="1"
          id="my-scrollbar"
        >
          <div className="sidebar-list navbar-collapse" id="sidebar">
            <VerticalNav />
          </div>
        </div>

        {/* FOOTER */}
        <div className="sidebar-footer"></div>

      </aside>
    </Fragment>
  );
});

export default Sidebar;